/**
 * Region pinning for Supabase Edge Function calls.
 *
 * Edge functions run at the edge region nearest the caller by default
 * (eu-central-1 for a caller in Georgia), then make every DB and auth call
 * back to the project's home region. A handler with five serial queries
 * pays five ~400 ms round trips. Pinning execution to the home region turns
 * those into local calls: one ~400 ms hop for the caller instead of five.
 *
 * The `x-region` header is honoured by the Supabase functions gateway. The
 * browser can only send it because every hermes CORS response lists it in
 * Access-Control-Allow-Headers. Keep the two in step.
 */
import { FunctionRegion } from '@supabase/supabase-js';

/** Supabase project Alfie-Pro: AWS ap-southeast-2 (Sydney). */
export const EDGE_FUNCTION_REGION = 'ap-southeast-2';

/** For `supabase.functions.invoke(name, { region })`. */
export const EDGE_FUNCTION_INVOKE_REGION = FunctionRegion.ApSoutheast2;

/** Spread into a plain headers object literal on a raw fetch to /functions/v1/. */
export const EDGE_FUNCTION_HEADERS = { 'x-region': EDGE_FUNCTION_REGION } as const;

/** Wrap an existing HeadersInit and add the region header. */
export function edgeFunctionHeaders(init?: HeadersInit): Headers {
  const headers = new Headers(init);
  headers.set('x-region', EDGE_FUNCTION_REGION);
  return headers;
}
